import { executeApp, get, post } from '@/utils/request'
import { FILE } from '@/api/defineRouting'

export function uploadFile({ file, data }: { file: File | Blob; data: { description?: string; obj_type: string; obj_id?: number; generate_sizes?: string[] } }) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify(data))
  return post({
    url: '/knowledge-service/file/upload',
    data: formData,
    // Không set headers content-type để axios tự nhận diện multipart/form-data
  })
}

export function downloadFile<T = any>(data: any) {
  return executeApp<T>(`${FILE.DOWNLOAD}`, data, 'get', { responseType: 'blob' })
}

export function deleteFile(file_id: string) {
  return get({
    url: `/knowledge-service/file/remove/${file_id}`,
  })
}

export function getDetailFile(file_id: any) {
  return get({
    url: `/knowledge-service/file/get-info?file_id=${file_id}`,
  })
}

export function getPathFile<T = any>(data: any) {
  return executeApp<T>(`${FILE.GET_PATH}`, data, 'get')
}
